module.exports = __webpack_public_path__ + "static/media/sc2.1f2d7d6d.png";